import { render, staticRenderFns } from "./tabContainer.vue?vue&type=template&id=1c7a9948&scoped=true&lang=pug&"
import script from "./tabContainer.vue?vue&type=script&lang=js&"
export * from "./tabContainer.vue?vue&type=script&lang=js&"
import style0 from "./tabContainer.vue?vue&type=style&index=0&id=1c7a9948&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a9948",
  null
  
)

export default component.exports